import * as extendActionType from '../extendActionType';

export const DOCTOR_ADD_CONTACT = 'contacts/DOCTOR_ADD_CONTACT';
export const ADD_CONTACT_DIALOG = 'contacts/ADD_CONTACT_DIALOG';
export const GET_CONTACTS_LIST = 'contacts/GET_CONTACTS_LIST';
export const CHANGE_CONTACTS_FILTER = 'contacts/CHANGE_CONTACTS_FILTER';
export const CHANGE_CONTACTS_ORDER = 'contacts/CHANGE_CONTACTS_ORDER';
export const DELETE_CONTACT = 'contacts/DELETE_CONTACT';
export const EDIT_CONTACT = 'contacts/EDIT_CONTACT';
export const EDIT_CONTACT_DIALOG = 'contacts/EDIT_CONTACT_DIALOG';
export const GET_CONTACTS_FOR_DROPDOWN = 'contacts/GET_CONTACTS_FOR_DROPDOWN';

export function addContact(data) {
    return {
        type: DOCTOR_ADD_CONTACT,
        httpRequest: {
            method: 'post',
            path: '/contacts',
            data,
        },
    };
}

export function getContactsList({
    offset, limit, filter, order,
}) {
    return {
        type: GET_CONTACTS_LIST,
        httpRequest: {
            method: 'post',
            path: '/contacts/list',
            data: {
                offset,
                limit,
                filter,
                order,
            },
        },
        offset,
        limit,
    };
}

export function getContactsListForDropdown(search) {
    return {
        type: GET_CONTACTS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/contacts/dropdown',
            params: {
                search,
            },
        },
    };
}

export function editContact(contactId, fields) {
    return {
        type: EDIT_CONTACT,
        httpRequest: {
            method: 'put',
            path: `/contacts/edit/${contactId}`,
            data: {
                ...fields,
            },
        },
        contactId,
        fields,
    };
}


export function changeContactsFilter(filter) {
    return {
        type: CHANGE_CONTACTS_FILTER,
        filter,
    };
}

export function changeContactsOrder(order) {
    return {
        type: CHANGE_CONTACTS_ORDER,
        order,
    };
}

export function deleteContact(contactId) {
    return {
        type: DELETE_CONTACT,
        httpRequest: {
            method: 'del',
            path: `/contacts/${contactId}`,
        },
        id: contactId,
    };
}

export function showAddContact() {
    return {type: extendActionType.show(ADD_CONTACT_DIALOG)};
}

export function hideAddContact() {
    return {type: extendActionType.clean(ADD_CONTACT_DIALOG)};
}

export function showEditContact(contact) {
    return {
        type: extendActionType.show(EDIT_CONTACT_DIALOG),
        contact,
    };
}

export function hideEditContact() {
    return {type: extendActionType.clean(EDIT_CONTACT_DIALOG)};
}



// WEBPACK FOOTER //
// ./src/reducers/contacts/contactsActions.js